module.exports = __webpack_public_path__ + "static/media/hourglass.d1039407.png";